<div id="legendContainerComp" style="height:18px;"></div>
